import tableStore from '../../store/TableStore';
import { WEvent } from './WEvent';

export class WLeaveTableEvent extends WEvent {
  needRemove: boolean;
  pid: string;

  constructor(event: WLeaveTableEvent) {
    super(event.tableId, event.eventType, event.eventTime);
    Object.assign(this, event);
  }

  public applyWebsocketChanges = (): Promise<void> => {
    if (this.needRemove) {
      tableStore.deleteTable(this.tableId);
      return Promise.resolve();
    } else {
      return tableStore.findActiveTableById(this.tableId).then(table => {
        table.setPlayers(
          table.players.map(player => {
            if (!player || player.pid === this.pid) {
              return null;
            }
            return player;
          }),
        );
        table.removeWaitingHostBot(this.pid);
        tableStore.changeFilterState();
      });
    }
  };
}
